import _ from "lodash"

/**
 * Highcharts plugin registry
 */
class HighchartsPluginRegistry {
  constructor() {
    this.plugins = {}
  }

  register(key, pluginFunc) {
    if (typeof pluginFunc !== "function") {
      throw new Error(`Invalid argument`)
    }
    _.set(this.plugins, key, pluginFunc)
  }

  remove(key) {
    _.unset(this.plugins, key)
  }

  applyPlugins(chartOpts, chart) {
    let overriddenConfig = chartOpts

    _.values(this.plugins).forEach((pluginFunc) => {
      // pipe all config, that erase previous one
      overriddenConfig = pluginFunc(overriddenConfig, chart)
    })
    if (overriddenConfig === undefined) {
      throw new Error(
        "Illegal state exception. Register plugin has return undefined, make sure it return a compliant Highcharts configuration"
      )
    }
    return overriddenConfig
  }

  getPlugins(key) {
    return _.get(this.plugins, key, undefined)
  }
}

/**
 * Export singleton that can be accessed in whole application
 */
export default new HighchartsPluginRegistry()
